<script>
import ActionWithTooltip from "@/components/ActionWithTooltip.vue";
import AudioButton from "@/components/AudioButton.vue";
import TouchOrMouseElement from "@/components/TouchOrMouseElement.vue";
import lang from "@/directives/lang";
import { MatomoHelper } from "@/helpers";
import { MatomoEventAction, MatomoEventCategory } from "@/types";

export default {
  name: "ArticleContentTranslationEntry",
  components: {
    ActionWithTooltip,
    AudioButton,
    TouchOrMouseElement
  },
  directives: {
    lang
  },
  props: {
    word: {
      type: String,
      required: true
    },
    direction: {
      type: String,
      required: true
    },
    pronunciation1: {
      type: String,
      default: undefined
    },
    pronunciation2: {
      type: String,
      default: undefined
    },
    comment: {
      type: String,
      default: undefined
    },
    inflections: {
      type: String,
      default: undefined
    },
    explanation: {
      type: String,
      default: undefined
    }
  },
  methods: {
    trackPronunciationClick() {
      MatomoHelper.sendEvent(
        MatomoEventCategory.Results,
        MatomoEventAction.ClickpPronunciation,
        "Pronunciation on translation"
      );
    }
  }
};
</script>

<template>
  <span class="article-content__text article-content__text--separator">
    <span v-if="comment" class="article-content__text article-content__text--category mr-1">{{
      comment
    }}</span>
    <span
      v-lang:target
      class="article-content__text article-content__text--primary article-content__text--prominent"
      v-html="word"
    ></span>
    <span class="article-content__translations-header-button-group ml-1 mr-2">
      <TouchOrMouseElement>
        <template #mouse>
          <ActionWithTooltip v-if="pronunciation1" class="ml-1" hide-on-click>
            <template #element>
              <AudioButton
                :audio-url="pronunciation1"
                :aria-label="$t('article.pronunciation.label')"
                @click="trackPronunciationClick()"
              />
            </template>
            <template #actionInitial>{{ $t("article.pronunciation.label") }}</template>
          </ActionWithTooltip>
          <ActionWithTooltip v-if="pronunciation2" class="ml-1" hide-on-click>
            <template #element>
              <AudioButton
                :audio-url="pronunciation2"
                :aria-label="$t('article.pronunciation.label')"
                @click="trackPronunciationClick()"
              />
            </template>
            <template #actionInitial>{{ $t("article.pronunciation.label") }}</template>
          </ActionWithTooltip>
        </template>
        <template #touch>
          <AudioButton
            v-if="pronunciation1"
            class="ml-1"
            :audio-url="pronunciation1"
            :aria-label="$t('article.pronunciation.label')"
            @click="trackPronunciationClick()"
          />
          <AudioButton
            v-if="pronunciation2"
            :audio-url="pronunciation2"
            class="ml-1"
            :aria-label="$t('article.pronunciation.label')"
            @click="trackPronunciationClick()"
          />
        </template>
      </TouchOrMouseElement>
    </span>

    <i
      v-if="explanation"
      v-lang:target
      class="article-content__text article-content__text--light mr-1"
      v-html="explanation"
    ></i>
    <span v-if="direction === 'daen' && inflections">
      &nbsp;
      <span
        class="article-content__inflections article-content__inflections--small"
        v-html="inflections"
      ></span>
    </span>
  </span>
</template>
